<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              required: true
            }),
            new fields.Input({
              label: 'Tekst',
              type: 'textarea',
              modelPath: [this, 'form', 'text'],
              multilingual: true,
              required: true
            }),
            new fields.Color({
              label: 'Kolor tła',
              modelPath: [this, 'form', 'color'],
              required: true
            }),
            new fields.Select({
              modelPath: [this, 'form', 'shape'],
              required: true,
              clearable: false,
              label: 'Kształt wycięcia',
              options: [
                { label: 'Okrąg', value: 'circle' },
                { label: 'Trapez', value: 'trapeze' }
              ]
            }),
            new fields.Switch({
              label: 'Tekst po prawej stronie',
              modelPath: [this, 'form', 'text_right']
            })
          ]
        }
      ]
    }
  }
}
</script>
